import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from './alert.service';

/**
 * Interface for alert messages
 */
interface AlertMessage {
  type: 'error' | 'success' | 'warning';
  link?: {
    path: string;
    param: string | number;
  };
  text?: string;
}

/**
 *  @author Hugo Andrés Escobar Ciceri
 *  @version 7.0.0
 *  Alert Component for the generic messages.
 */

@Component({
    selector: 'kanzi-apes-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {
  message: AlertMessage | null = null;
  isVisible: string;
  title = '';
  displayMessage = false;

  /**
   * @param alertService {AlertService} Service to send and receive messages
   * @param router {Router}
   */
  constructor(private alertService: AlertService, private router: Router) {
    this.isVisible = 'none';
  }

  ngOnInit() {
    this.alertService.getMessage().subscribe({
      next: (message: AlertMessage) => {
        if (message) {
          this.message = message;
          this.displayMessage = true;
          this.isVisible = 'block';
          if (this.message.type === 'error') {
            this.title = 'alerts.alert';
          } else if (
            this.message.type === 'success' ||
            this.message.type === 'warning'
          ) {
            this.title = 'alerts.message';
          }
        }
      },
      error: (error: unknown) => {
        console.log(error);
      },
    });
  }

  /**
   * Navigates to the component referenced by the current alert message link,
   * then closes the alert. When the link has no `param` (falsy value such as an
   * empty string), it navigates using only `path` to avoid producing a URL with
   * a trailing empty segment (e.g. `list/`), which would break relative links on
   * the destination page.
   * @returns void
   */
  goDetail() {
    if (this.message?.link) {
      const { path, param } = this.message.link;
      if (param) {
        this.router.navigate([path, param]);
      } else {
        this.router.navigate([path]);
      }
    }
    this.message = null;
    this.isVisible = 'none';
    this.displayMessage = false;
  }

  /**
   * Close the modal alert.
   */
  closeModal() {
    this.message = null;
    this.isVisible = 'none';
    this.displayMessage = false;
  }
}
